export default __webpack_public_path__ + "static/logo4-31968491bb77146086097c0573233a3f.png";